import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { Table } from '../..'
import logsTableDisplay from './ActionLogs.table'
import { usePageTitle } from '../../../actions/app'

const ActionLogs = ({
    onChangeSearch,
    valueSearch,
    logs,
    onChangeSelected,
    children,
    calculateStatusColor,
    calculateMethodColor,
    sortable,
    onChangeSort,
    nextPage,
    t,
}) => {
    usePageTitle(t('Logs'))

    return (
        <Table
            data={logs}
            display={logsTableDisplay({
                onChangeSelected,
                calculateStatusColor,
                calculateMethodColor,
                t,
            })}
            nextPage={nextPage}
            keyField="id"
            title={t('Logs')}
            onChangeSearch={onChangeSearch}
            valueSearch={valueSearch}
            sortableByAPI={sortable}
            sortable
            onChangeSort={onChangeSort}
        >
            {children}
        </Table>
    )
}

ActionLogs.propTypes = {
    logs: PropTypes.arrayOf(PropTypes.shape({})),
    onChangeSearch: PropTypes.func,
    valueSearch: PropTypes.string,
    onChangeSelected: PropTypes.func,
    children: PropTypes.node,
    calculateStatusColor: PropTypes.func,
    calculateMethodColor: PropTypes.func,
    sortable: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.arrayOf(
            PropTypes.shape({
                fieldToSort: PropTypes.string,
                sortType: PropTypes.string,
            })
        ),
    ]),
    onChangeSort: PropTypes.func,
    nextPage: PropTypes.func,
    t: PropTypes.func.isRequired,
}

ActionLogs.defaultProps = {
    logs: [],
    onChangeSearch: null,
    valueSearch: '',
    onChangeSort: () => null,
    sortable: true,
    onChangeSelected: null,
    children: null,
    calculateStatusColor: null,
    calculateMethodColor: null,
    nextPage: null,
}

export default withTranslation()(ActionLogs)
